import React from 'react';
import Container from 'react-bootstrap/Container';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

/**
 * Reusable Page Hero component for inner pages
 * @param {string} title - Main heading
 * @param {string} subtitle - Description text
 * @param {string} backgroundImage - Path to background image
 * @param {array} breadcrumbs - Array of {label, path} objects
 */
const PageHero = ({
  title,
  subtitle,
  backgroundImage = './assets/homepage.jpeg',
  breadcrumbs = []
}) => {
  return (
    <section
      className="page-hero"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="page-hero-overlay"></div>
      <Container className="page-hero-content">
        {breadcrumbs.length > 0 && (
          <nav className="page-breadcrumbs" aria-label="Breadcrumb">
            <Link to="/" className="breadcrumb-link">Home</Link>
            {breadcrumbs.map((crumb, index) => (
              <React.Fragment key={index}>
                <FontAwesomeIcon icon={faChevronRight} className="breadcrumb-separator" />
                {crumb.path ? (
                  <Link to={crumb.path} className="breadcrumb-link">{crumb.label}</Link>
                ) : (
                  <span className="breadcrumb-current">{crumb.label}</span>
                )}
              </React.Fragment>
            ))}
          </nav>
        )}
        <h1 className="page-hero-title">{title}</h1>
        {subtitle && <p className="page-hero-subtitle">{subtitle}</p>}
      </Container>
    </section>
  );
};

export default PageHero;
